import React, { useState, useEffect } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import Autosuggest from "react-autosuggest";

const MIN_COMPANY_CHARS = 4;

export default function Jc_amc() {
  const { http } = AuthUser();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    company: "",
    email: "",
    description: "",
    priority: "",
    is_resolve: "No",
  });

  const initialState = {
    name: "",
    phone: "",
    company: "",
    email: "",
    description: "",
    priority: "",
    is_resolve: "No",
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [company, Setcompany] = useState([]);
  useEffect(() => {
    http.get(`/get_amc_company`).then((res) => {
      const list = Array.isArray(res.data.data) ? res.data.data : [];
      // Ensure unique names client-side as well
      const seen = new Set();
      const unique = [];
      list.forEach((name) => {
        const trimmed = String(name || "").trim();
        if (!trimmed) return;
        const key = trimmed.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        unique.push(trimmed);
      });
      Setcompany(unique);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }
    try {
      await http.post("/amc_add", form);
      toast.success("Enquiries sent successfully!");
      setFormData(initialState);
    } catch (error) {
      toast.error("Something went wrong, try again");
      console.error("Error adding company:", error.response?.data);
    }
  };

  const [suggestions, setSuggestions] = useState([]);

  const normalizeCompany = (name) =>
    String(name || "")
      .replace(/^\(I\)\s*/i, "")
      .trim()
      .toLowerCase();

  const getSuggestions = (inputValue) => {
    const q = String(inputValue || "").trim().toLowerCase();
    if (q.length < MIN_COMPANY_CHARS) return [];

    const starts = [];
    const contains = [];
    const seen = new Set();

    company.forEach((c) => {
      const key = c.toLowerCase();
      if (seen.has(key)) return;
      const normalized = normalizeCompany(c);
      if (normalized.startsWith(q) || key.startsWith(q)) {
        seen.add(key);
        starts.push(c);
      } else if (normalized.includes(q) || key.includes(q)) {
        seen.add(key);
        contains.push(c);
      }
    });

    return [...starts, ...contains].slice(0, 40);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    setFormData((prev) => ({
      ...prev,
      company: suggestion,
    }));
  };

  const onCompanyInputChange = (event, { newValue }) => {
    setFormData((prev) => ({
      ...prev,
      company: newValue,
    }));
  };

  const renderSuggestion = (suggestion) => <div>{suggestion}</div>;

  const inputProps = {
    placeholder: "Type at least 4 letters to search company",
    name: "company",
    value: formData.company,
    onChange: onCompanyInputChange,
    className: "form-control",
    required: true,
    autoComplete: "off",
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="col-md-6 col-sm-6">
        <div className="container mt-4">
          <Toaster />
          <div className="text-center">
            <img
              src="/ticket.jpeg"
              alt="Ticket"
              style={{ maxWidth: "100%", height: "auto" }}
            />
            <h3>KATZE - Customer Service Request Form</h3>
            <p>
              (Kindly raise the TICKET our team will get in touch with you
              immediately.)
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group mt-3">
              <label>Email</label>
              <input
                name="email"
                type="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group mt-3">
              <label>Company / Institutions Name</label>
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                onSuggestionSelected={onSuggestionSelected}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={(value) =>
                  String(value || "").trim().length >= MIN_COMPANY_CHARS
                }
                inputProps={inputProps}
                theme={{
                  container: "suggestion-container",
                  suggestionsList: "suggestion-list",
                  suggestion: "suggestion-item",
                  suggestionHighlighted: "suggestion-item suggestion-item-active",
                }}
              />
            </div>

            <div className="form-group mt-3">
              <label>Name of the Person</label>
              <input
                name="name"
                type="text"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group mt-3">
              <label>Contact Number to reach you</label>
              <input
                name="phone"
                type="number"
                className="form-control"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group mt-3">
              <label>Complaint / Issue details ?</label>
              <textarea
                name="description"
                className="form-control"
                value={formData.description}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="form-group mt-3">
              <label>Priority</label>
              <select
                className="form-control"
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                required
              >
                <option value="">Select Any </option>
                <option value="Medium">Medium </option>
                <option value="High">High </option>
                <option value="Low">Low </option>
              </select>
            </div>

            <button className="btn button btn-success mt-3" type="submit">
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
